import './Main.css';
import '../../styles/nav-icon.css';

import {useState} from 'react';
import {
  Link,
  Navigate,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from 'react-router-dom';

import {useAuth} from '../../contexts/AuthContext';
import HomePage from './HomePage';
import Resources from './Resources';
import Settings from './Settings';

const Main = () => {
  const {user, logout} = useAuth();
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = async () => {
    setError('');
    setLoading(true);

    try {
      await logout();
      navigate('/login');
    } catch (error) {
      setError('Failed to log out');
      console.error('Logout error:', error);
    } finally {
      setLoading(false);
    }
  };

  const isActive = (path) => {
    return (
      location.pathname === path ||
      (path !== '/dashboard' && location.pathname.startsWith(path))
    );
  };

  return (
    <div className='dashboard-container'>
      <div className='burger-button'>
        <button className='nav-icon-btn' onClick={() => setMenuOpen(!menuOpen)}>
          <div
            className={`nav-icon ${menuOpen ? 'nav-icon--active' : ''}`}
          ></div>
        </button>
      </div>

      {menuOpen && (
        <div className='overlay' onClick={() => setMenuOpen(false)} />
      )}

      <div className={`sidebar ${menuOpen ? 'open' : ''}`}>
        <div className='logo'>Tenvos AI</div>
        <nav className='nav-menu'>
          <Link
            to='/dashboard'
            onClick={() => setMenuOpen(false)}
            className={`nav-item ${
              isActive('/dashboard') && location.pathname === '/dashboard'
                ? 'active'
                : ''
            }`}
          >
            Home
          </Link>
          <Link
            to='/dashboard/resources'
            onClick={() => setMenuOpen(false)}
            className={`nav-item ${isActive('/dashboard/resources') ? 'active' : ''}`}
          >
            Resources
          </Link>
          <Link
            to='/dashboard/settings'
            onClick={() => setMenuOpen(false)}
            className={`nav-item ${isActive('/dashboard/settings') ? 'active' : ''}`}
          >
            Settings
          </Link>
        </nav>
      </div>

      <div className='main-area'>
        <header className='dashboard-header'>
          <div className='user-info'>
            <span>
              {user?.first_name} {user?.last_name}
            </span>
            <button
              onClick={handleLogout}
              className='logout-button'
              disabled={loading}
            >
              {loading ? 'Logging out...' : 'Logout'}
            </button>
          </div>
        </header>

        {error && <div className='dashboard-error'>{error}</div>}

        <main>
          <Routes>
            <Route path='/' element={<HomePage />} />
            <Route path='/resources' element={<Resources />} />
            <Route path='/settings' element={<Settings />} />
            <Route path='*' element={<Navigate to='/dashboard' replace />} />
          </Routes>
        </main>
      </div>
    </div>
  );
};

export default Main;
